import { Component } from '@angular/core';

@Component({
  selector: 'sui-book-sub-content-tag',
  templateUrl: './book-sub-content-tag.component.html',
  styleUrl: './book-sub-content-tag.component.scss',
})
export class BookSubContentTagComponent {}
